import template from './index.html'
import fullscreen from './fullscreen.html'

const modalDialog = (params) => {
  return {
    isOpen: false,
    type: params.type || 'default',
    className: params.class || '',
    body: '',
    show: false,
    async init() {
        this.body = this.$el.innerHTML
        if (this.type == 'fullscreen') {
          this.$el.innerHTML = fullscreen
        } else {
          this.$el.innerHTML = template
        }
    },
  }
}

export { modalDialog }
